module.exports = __webpack_public_path__ + "img/1.d6a8a789.png";